import {
  Marker as GoogleMapMarker,
  MarkerClusterer,
} from '@react-google-maps/api';

import { IMarkerProps } from './marker-cluster.models';
import { LIST_ZOOM } from '../../../constants/ecp-locator';
import {
  getMarkerIcon,
  getLatLng,
} from '../../../utils/ecp-locator';

export const MarkerCluster = ({
  ecpStores,
  onMarkerLoad,
  onMarkerClick,
  markerCode,
  ...props
}: IMarkerProps): JSX.Element => {

  return (
    <MarkerClusterer
      maxZoom={LIST_ZOOM}
    >
      {(clusterer) => (
        <>
          {ecpStores.map((store) => (
            <GoogleMapMarker
              position={getLatLng(store!)}
              key={store.code}
              icon={getMarkerIcon(store!.type, store!.code, markerCode!)}
              onLoad={onMarkerLoad && ((marker: google.maps.Marker) => onMarkerLoad(marker, store!))}
              onClick={onMarkerClick && ((event: google.maps.MapMouseEvent) => onMarkerClick(event, store!))}
              title={store && `${store.name} ${store.street}`}
              clusterer={clusterer}
              {...props}
            />
          ))}
        </>
      )}
    </MarkerClusterer>
  );
};
